import {
  GET_ORGANIZATIONS,
  CREATE_ORGANIZATIONS,
  DELETE_ORGANIZATIONS,
  UPDATE_ORGANIZATIONS,
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
} from './actionType';

// common success
export const OrganizationsApiResponseSuccess = (actionType, data) => ({
  type: API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const OrganizationsApiResponseError = (actionType, error) => ({
  type: API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const Organizations = (id) => ({
  type: GET_ORGANIZATIONS,
  payload: { id },
});

export const CreateOrganizations = (data, history) => ({
  type: CREATE_ORGANIZATIONS,
  payload: { data, history },
});

export const UpdateOrganizations = (id, data, history) => ({
  type: UPDATE_ORGANIZATIONS,
  payload: { id, data, history },
});

export const DeleteOrganizations = (id) => ({
  type: DELETE_ORGANIZATIONS,
  payload: { id },
});
